<template>
  <div class="page__wrapper" @scroll="onScroll()">
    <FCSpecs :h2="h2" :h3="h3" :specs="specs" />
  </div>
</template>

<script>
import FCSpecs from "@/components/patterns/FCSpecs";
export default {
  components: {
    FCSpecs,
  },
  mounted() {
    const ref = this.$store.state.menu.bailey.ref;
    const index = this.$store.state.menu.menuItems
      .map((e) => e.ref)
      .indexOf(ref);
    this.$store.state.menu.activeSection = index;
    this.$store.state.menu.currentSectionTitle = this.$store.state.menu.bailey.title;
    this.$store.state.menu.currentSectionNavigation = this.$store.state.menu.bailey.nav;
    this.onScroll();
  },
  data() {
    return {
      h2: "The Bailey",
      h3: "Specs",
      specs: [
        {
          icon: "location.png",
          text: `<strong>LOCATION</strong><br/><br/>Encompassing the entire north end of the stadium, The Bailey will be a massive wall of noise and color towering behind the goal at a 34-degree angle – as steep as legally allowed. The Bailey starts at field level, a mere 18.5 feet from the field.`,
        },
        {
          icon: "sqft.svg",
          text: `<strong>SIZE</strong><br/><br/>The Bailey at West End Stadium will be nearly twice the size than at Nippert Stadium, holding 3,170 fans.`,
        },
        {
          icon: "tifo.png",
          text: `<strong>TIFO</strong><br/><br/>The Bailey will have a built-in overhead tifo rigging system, which will allow for giant, 100+ foot tifos to rise and hang over the section.`,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.page__wrapper {
  background-image: url("~@/assets/backgrounds/bg-thebailey.jpg");
  background-size: cover;
  background-position: center;
}
</style>